export default __webpack_public_path__ + "static/media/bg26.c60b07fa.jpg";